export default {
  computed: {
    isMobile() {
      return this.isMobileWidth;
    },
    isTablet() {
      return this.isTabletWidth;
    },
  },
  data() {
    return {
      isMobileWidth: false,
      mobileWidth: 576,
      isTabletWidth: false,
      tabletWidth: 1000,
    };
  },
  methods: {
    onResize() {
      this.isMobileWidth = window.innerWidth <= this.mobileWidth;
      this.isTabletWidth = window.innerWidth <= this.tabletWidth;
    },
  },
  mounted() {
    this.isMobileWidth = window.innerWidth <= this.mobileWidth;
    this.isTabletWidth = window.innerWidth <= this.tabletWidth;
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      this.onResize();
    });
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
};
